const errorsToRedirect = [
    'unavailable',
    'lowStock',
    'noStock',
    'minOrderQuantityNotReached',
    'maxOrderQuantityExceeded',
];

const errorsToStop = ['allOutOfStock', 'allUnavailable'];

export { errorsToRedirect, errorsToStop };
